
import moment from 'moment'
import { _menuList } from '../../static/api/index'
// import {getMenu} from '../../static/utils/index'
import MenuTree from './menuTree.vue'
import Footer from './footer.vue'
export default {
    name: 'Home',
    components: {
        MenuTree,
        Footer
    },
    data() {
        return {
            moment,
            time: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
            btcTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            clearInt: null,
            footerArr: window.fyEarth.footer,
            logoArea: '',
            // 头部导航
            navList: [],
            menuActive: 0,

            // 左侧导航
            menuList: [],
            // 当前打开的 sub-menu 的 的数组
            activeItemArr: [], 
            // 当前激活的菜单项
            defaultActiveIndex: '',
            // 向子组件传参
            parentMenuItem: {},
            // 右侧数据
            menuGetItem: {},
            thisOpenMenuItem: '',
            itemObj: {},
            logoName: '',
            routerCurrent: {},
            // 是否显示左侧menu
            isShowMenu: true
        }
    },
    created() {
        // 获取?参数
        // var areaQuery = new UrlSearch()
        // 点击横向导航存储area,拼接path跳转
        // localStorage.setItem('AREA_LOGO', areaQuery.area)
        // 获取路由params
        let areaQuery = this.$router.history.current.params.area
        // 区域LOGO
        let logoName = ''
        if(areaQuery == 'arab'){
            logoName = 'arab states'
        } else if(areaQuery == 'uae'){
            logoName = 'UAE'
        } else{
            logoName = areaQuery
        }
        this.logoName = logoName
        this.$store.state.logo = areaQuery

        // this.groupTitle = localStorage.getItem('groupTitle')
        // this.group = this.$router.history.current.query.group
        // 横向导航
        this.getNav()
        // const htmlDom = document.getElementsByTagName('html')[0];
        // htmlDom.style.fontSize = '16px'
    },
    // watch: {
        // $route: {
        //     handler: function(newVal, oldVal){
        //         if(newVal.path !== oldVal.path){
        //             let par_id = this.menuList[0]._id, this_id = ''
        //             console.log('menuList', this.menuList)
        //             localStorage.setItem('parent_id', par_id)
        //             if(this.menuList[0].children?.length){
        //                 this_id = this.menuList[0].children[0]._id
        //             } else {
        //                 this_id = this.menuList[0]._id
        //             }         
        //             localStorage.setItem('item_id', this_id)

        //             console.log('监听id', '父-', par_id, '当前', this_id)
        //             this.getNav()
                    
        //         }
        //     },
        //     // 初次加载时执行
        //     immediate: true,
        //     // 深度观察监听
        //     // deep: true,
        //     // 在观测到数据变动之后 同步执行 这样会防止渲染发生错乱
        //     // flush: 'sync',
        // }
    // },
    mounted(){
        this.clearInt = setInterval(()=>{
          this.time = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          this.btcTime = moment().format('YYYY-MM-DD HH:mm:ss')
        }, 1000)
    },
    beforeDestroy() {
        this.clearInt && clearInterval(this.clearInt)
    },
    methods: {
        // 获取横向导航
        getNav(){
            // let params = this.$store.state.logo == 'asia' ? 'FYEarth' : this.$store.state.logo == 'global' ? 'FYEarth-global' : ''
            // console.log('params', params)
            let params = {
                app: window.fyEarth.menuType
            }
            let _data = [], datas = [], _nav = [], _item = {}
            _menuList(this.$store.state.logo, params).then((result)=>{
                _data = result.data
                if(_data.length){
                    let areaQuery = this.$router.history.current.params.area
                    datas = _data
                    if(areaQuery == 'asia'){
                        datas = [
                            ..._data,
                            {
                                abbr: "InteractiveAnalysis",
                                cnName: "云图动画", 
                                enName: "InteractiveAnalysis", 
                            }
                        ]
                    }   
                    if(areaQuery == 'arab'){
                        datas = [
                            
                            {
                                abbr: "home",
                                cnName: "Home", 
                                enName: "Home", 
                            },
                            ..._data,
                        ]
                    }    
                    window.fyEarth.headerNav.forEach((value, index)=>{
                        datas.forEach((val, idx)=>{
                            if(value.abbr == val.abbr){
                                _item = {
                                    path: value.path,
                                    enName: val.enName,
                                    cnName: val.cnName,
                                    icon: value.icon,
                                    code: val.code
                                }
                                _nav.push(_item)
                            }
                        })
                    })
                    this.navList = _nav
                    // 导航默认选中
                    const menuSubID = localStorage.getItem('subID')
                    // console.log('menuSubID', menuSubID)
                    const tabIndex = localStorage.getItem('fyearth-tabIndex') || 0
                    this.active(this.navList[tabIndex], tabIndex, menuSubID)
                }
            })
        },
        /**
         * 横向导航点击事件
         * item 当前选中的menu数据
         * tabIndex 当前选中的menu的index
         * menuSubID 当前的menu ID
         * */ 
        active(item, index, menuSubID){
            this.isShowMenu = true
            if(item.path == '/InteractiveAnalysis') this.isShowMenu = false
            let areaQuery = this.$router.history.current.params.area
            if(item.path == '/home' && areaQuery == 'arab') this.isShowMenu = false
            this.menuActive = index
            localStorage.setItem('fyearth-tabIndex', index)
            // 切换横向导航先清空数据,解决切换横向导航,数据数据错乱问题
            this.parentMenuItem = {}
            this.getMenu(item.code, menuSubID)

            this.$store.commit('NAV_TITLE', item.enName)
        },

        // 添加level字段拼接
        generateRoutesWithFullPath(menuData, basePath = '', level = 1) {
            return menuData.map(item => {
                const fullPath = basePath === '/' ? `${basePath}${item.url}` : `${basePath}/${item.url}`;
                const route = {
                    ...item,
                    level: level,
                    // children:  _children
                }
               
                if (item.children && item.children.length) {             
                    // 递归处理子菜单，并传入当前项的完整路径作为 basePath
                    route.children = this.generateRoutesWithFullPath(item.children, fullPath, level + 1);
                }

                return route;
            })
        },

        /**
         * @params {String} tabPathName 当前的menu类型 来着横向导航的enName
         * @params {} menuSubID
         * **/ 
        getMenu(tabPathName){
            // let params = this.$store.state.logo == 'asia' ? 'FYEarth' : this.$store.state.logo == 'global' ? 'FYEarth-global' : ''
            let _data = []
            this.menuList = []
            let isFinal_0 = '0'
            let params = {
                menu: tabPathName,
                isFinal: isFinal_0,
                app: window.fyEarth.menuType
            }
            _menuList(this.$store.state.logo, params).then((result)=>{
                _data = result.data // this.generateRoutesWithFullPath(result.data)
                let _data2 = [
                    {
                        "_id": "64227f3be2eacd549884bff4",
                        "cnName": "云图",
                        "isFinal": "0",
                        "code": "01010000",
                        "enName": "Cloud Image",
                        "prodName": "",
                        "subProdSeq": [],
                        "about": "",
                        "region": [],
                        "abbr": "Cloud Image",
                        "application": [
                            "FYEarth-Test",
                            "FYEarth-Production"
                        ],
                        "children": [
                            {
                                "_id": "64225955e2eacd549884bd7c",
                                "cnName": "极轨卫星全球影像",
                                "isFinal": "0",
                                "code": "01010100",
                                "enName": "Polar Orbiting Global Image",
                                "prodName": "Polar Orbiting Global Image",
                                "subProdSeq": [],
                                "about": "",
                                "region": [],
                                "abbr": "Polar Orbiting",
                                "application": [
                                    "FYEarth-Test",
                                    "FYEarth-Production"
                                ],
                                "children": [
                                    {
                                        "_id": "642e91a594fdda55adaca3c4",
                                        "cnName": "真彩色云图",
                                        "isFinal": "1",
                                        "code": "01010105",
                                        "enName": "FY-3D GeoColor",
                                        "prodName": "GCLR",
                                        "subProdSeq": [],
                                        "about": "",
                                        "region": [],
                                        "prodType": "video",
                                        "abbr": "FY-3D GeoColor",
                                        "application": [
                                            "FYEarth-Test",
                                            "FYEarth-Production"
                                        ],
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "_id": "642254dfe2eacd357876d914",
                                "cnName": "静止卫星全球拼图",
                                "isFinal": "0",
                                "code": "01010200",
                                "enName": "GEO Satellite Global Image",
                                "prodName": "",
                                "subProdSeq": [],
                                "about": "",
                                "region": [],
                                "abbr": "GEO Satellite Global Image",
                                "application": [
                                    "FYEarth-Test",
                                    "FYEarth-Production"
                                ],
                                "children": [
                                    {
                                        "_id": "64225542e2eacd357876d915",
                                        "cnName": "长波红外通道彩色合成",
                                        "isFinal": "1",
                                        "code": "01010201",
                                        "enName": "Long-Wave IR,Colored GEO Satellite Global Image(IR 10.8um)",
                                        "prodName": "ColoredGEO",
                                        "subProdSeq": [],
                                        "about": "",
                                        "region": [],
                                        "url": "http://img.nsmc.org.cn/CLOUDIMAGE/GEOS/MOS/IRX/VIDEO/GEOS.MOS.IRX.GBAL.24h.mp4?mt=337",
                                        "prodType": "video",
                                        "abbr": "IR Colored",
                                        "application": [
                                            "FYEarth-Test",
                                            "FYEarth-Production"
                                        ],
                                        "children": []
                                    },
                                    {
                                        "_id": "64225563e2eacd357876d916",
                                        "cnName": "长波红外通道增强",
                                        "isFinal": "1",
                                        "code": "01010202",
                                        "enName": "Long-Wave IR, Enhanced GEO Satellite Global Image(IR 10.8um)",
                                        "prodName": "EnhancedGEO",
                                        "subProdSeq": [],
                                        "about": "",
                                        "region": [],
                                        "url": "http://img.nsmc.org.cn/CLOUDIMAGE/GEOS/COL/IRX/VIDEO/GEOS.COL.IRX.GBAL.24h.mp4?mt=835",
                                        "prodType": "video",
                                        "abbr": "IR Enhance",
                                        "application": [
                                            "FYEarth-Test",
                                            "FYEarth-Production"
                                        ],
                                        "children": []
                                    },
                                    {
                                        "_id": "64225576e2eacd357876d917",
                                        "cnName": "长波红外通道黑白",
                                        "isFinal": "1",
                                        "code": "01010203",
                                        "enName": "Long-Wave IR GEO Satellite Global Image(IR 10.8um)",
                                        "prodName": "IRGEO",
                                        "subProdSeq": [],
                                        "about": "",
                                        "region": [],
                                        "url": "http://img.nsmc.org.cn/CLOUDIMAGE/GEOS/GRA/IRX/VIDEO/GEOS.GRA.IRX.GBAL.24h.mp4?mt=734",
                                        "prodType": "video",
                                        "abbr": "IR 10.8um",
                                        "application": [
                                            "FYEarth-Test",
                                            "FYEarth-Production"
                                        ],
                                        "children": []
                                    },
                                    {
                                        "_id": "64225586e2eacd357876d918",
                                        "cnName": "水汽通道",
                                        "isFinal": "1",
                                        "code": "01010204",
                                        "enName": "Water Vapour, Colored GEO Satellite Global Image(IR 10.8um)",
                                        "prodName": "WaterVapourColoredGEO",
                                        "subProdSeq": [],
                                        "about": "",
                                        "region": [],
                                        "url": "http://img.nsmc.org.cn/CLOUDIMAGE/GEOS/MOS/WVX/VIDEO/GEOS.MOS.WVX.GBAL.24h.mp4?mt=539",
                                        "prodType": "video",
                                        "abbr": "Water Vapour",
                                        "application": [
                                            "FYEarth-Test",
                                            "FYEarth-Production"
                                        ],
                                        "children": []
                                    },
                                    {
                                        "_id": "642e924194fdda55adaca3d1",
                                        "cnName": "大气环流情况",
                                        "isFinal": "1",
                                        "code": "01010205",
                                        "enName": "Atmospheric circulation situation",
                                        "prodName": "ACS",
                                        "subProdSeq": [
                                            "ACS-CH1-CMAGFS-SSP",
                                            "ACS-CH1-CMAGFS"
                                        ],
                                        "about": "This product is mainly used to represent a wide\n range of atmospheric operation phenomena,\n including satellite infrared image,500hPa geopotential height and 850hPa wind elements. ",
                                        "region": [],
                                        "prodType": "img",
                                        "abbr": "Circulation",
                                        "application": [
                                            "FYEarth-Test",
                                            "FYEarth-Production"
                                        ],
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
                this.menuList = _data;
                if(_data.length){
                    
                    // 获取当前点击的父级id
                    // const parent_id = localStorage.getItem('parent_id') == null || localStorage.getItem('parent_id') !== 'undefined' ? localStorage.getItem('parent_id') : _data[0].code
                    // console.log('parent_id', parent_id)
                    // 获取当前点击的id
                    // const item_id = localStorage.getItem('item_id') == null || localStorage.getItem('item_id') !== 'undefined' ? localStorage.getItem('item_id') : _data[0].code
                    // console.log('item_id',item_id)
                    // 默认打开组
                    // const openKey = localStorage.getItem('openGroup') || _data[0]._id

                    // 默认打开第一个组，如存在多级数据，调用打开handleOpen组函数，取第一个组第一条数据， 否则，直接调用handleSelect点击菜单函数
                    let par_id = _data[0].code, this_id = ''
                    if(_data[0].children?.length){
                        // this_id = _data[0].children[0].code
                        this.handleOpen(par_id, [par_id])
                    } else {
                        // 获取当前点击的id
                        // this_id = _data[0].code
                        // this.handleSelect(this_id, [par_id, this_id])
                        // 获取local信息，如无数据，则获取所有层级的第一个code
                        let getIdList = []
                        let keyPathLocal = localStorage.getItem(window.location.pathname + '_keyPath')
                        if(keyPathLocal == null){
                            getIdList = this.getIdList([this.menuGetItem])
                        } else {
                            let keyPathLocalArr = keyPathLocal.split(',')
                            getIdList = keyPathLocalArr
                        }
                        console.log(getIdList)
                        this.handleSelect(getIdList[getIdList.length - 1], getIdList)
                        
                    }          
                }
            })
        },
 
        /**
         * 打开菜单组
         * @params {String} key 打开的index
         * @params {Array} keyPath 
         * 
         * **/ 
        handleOpen(key, keyPath) {
            //console.log('打开菜单组', key, 'keyPath',keyPath);
            localStorage.setItem('openGroup', key)

            this.thisOpenMenuItem = key
            // console.log('thisOpenMenuItem', this.thisOpenMenuItem)

            localStorage.setItem('image-time', 0)
            
            // 获取右侧信息
            this.findItem(this.menuList, key)
            // console.log('menuGetItem-open', this.menuGetItem)

            // 备份代码
            // 当前打开的 sub-menu 的 的数组
            // this.activeItemArr = keyPath
            // 当前id [父级id 当前id]
            // this.handleSelect(this.menuGetItem.children[0].code, [key, this.menuGetItem.children[0].code])
               
            // 测试代码
            // this.activeItemArr = getIdList
            // this.activeItemArr = ['03020000', '03020100', '03020101']
            // this.handleSelect('03020101', ['03020000', '03020100', '03020101'])

            // 获取所有层级的第一个code
            let getIdList = []
            let keyPathLocal = localStorage.getItem(window.location.pathname + '_keyPath')
            
            if(keyPathLocal == null){
                getIdList = this.getIdList([this.menuGetItem])
            } else {
                let keyPathLocalArr = keyPathLocal.split(',')
                getIdList = keyPathLocalArr
            }
            this.handleSelect(getIdList[getIdList.length - 1], getIdList)
        },

        /**
         * 获取
         * data {this.menuList}
         * val {code}
         * */ 

        foundFar(data, val) {
            for (var i = 0; i < data.length; i++) {
                if (data[i] && data[i].code == val) {
                    return [];
                }
                if (data[i] && data[i].children) {
                    var far = this.foundFar(data[i].children, val);
                    if (far) {
                        return far.concat(data[i].code);
                    }
                }
            }
        },

        /**
         * 获取每层的第一个code数据
         * list { array } 要处理的数组
         * 
        */
        getIdList(list) {
            const result = []
            while (list && list.length) {
                result.push(list[0].code)
                list = list[0].children
            }
            return result
        },

        /**
         * 点击菜单项
         * @param {String} value 当前点击的_id
         * @param {Array} keyPath [父级id，当前id]
         * 
         */

        handleSelect(value, keyPath) {
            //console.log('点击菜单组', value, keyPath)
            localStorage.setItem(window.location.pathname + '_keyPath', keyPath)

            // 当前id
            localStorage.setItem('item_id', value)
            localStorage.setItem('item_code', value)

            // 父级id
            localStorage.setItem('parent_id', keyPath[keyPath.length - 1])
            
            localStorage.setItem('parent_code', keyPath[keyPath.length - 1])

            this.findItem(this.menuList, value)
            
            localStorage.setItem('dataType', this.menuGetItem.dataType)

            localStorage.setItem('prodName', this.menuGetItem.prodName)

            localStorage.setItem('prodType', this.menuGetItem.prodType)

            localStorage.setItem('prodCode', this.menuGetItem.code)

            // 当前激活的菜单项
            this.defaultActiveIndex = this.menuGetItem.code

            // 向子组件传参
            this.parentMenuItem = this.menuGetItem
            
            if(Object.keys(this.menuGetItem).length){
                // 区域数据
                this.$store.commit('REGION_LENGTH', this.menuGetItem.region.length)
            } else {
                this.$store.commit('REGION_LENGTH', 0)
            }
        },

        /**
         * 
         * @param {any[]} arr 搜索范围
         * @param {string} _id 搜索目标
         * @returns {Object} res 返回结果
         */

        findItem(arr, code, parent) {
            if(!parent){
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].code == code) {
                        return this.menuGetItem = arr[i]
                    }
                    if (arr[i].children.length) {
                        this.findItem(arr[i].children, code);
                    }
                }
            } else {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].code == code) {
                        return this.subArr.push(arr[i].code)
                    }
                    if (arr[i].children.length) {
                        this.findItem(arr[i].children, code);
                    }
                }
            }
        },

        // 关闭菜单组
        handleClose(key, keyPath) {
            console.log('关闭菜单组',key, keyPath);
            // this.activeItemArr = []
            // this.activeItemArr = keyPath
        },

        // 回到主页
        gotoHomepage(){
            window.open(window.fyEarth.logoGotoHome, 'FengYun Earth')
            // win.focus ();  //让原窗口获取焦点 
        },
    }
}